import React from "react";

const WhereUsedContent = ({ serviceKey, isEnabled, title }) => {
  let content = null;

  if (serviceKey === "media") {
    content = "Used for Product Images and Videos.";
  } else if (serviceKey === "twilio") {
    content = (
      <>
        <div>
          <h3 className="text-lg font-bold mb-2">With SMS:</h3>
          <p>
            Registration: Registration &rarr; OTP Verification &rarr; Approval
            from Dashboard.
          </p>
          <p>
            Forgot Password: Forgot Password &rarr; Verify with OTP &rarr; Reset
            Password.
          </p>
        </div>
        <div className="mt-4">
          <h3 className="text-lg font-bold mb-2">Without SMS:</h3>
          <p>Registration: Registration &rarr; Approval from Dashboard.</p>
          <p>
            Forgot Password: Request Forgot Password &rarr; Admin Approval from
            Dashboard &rarr; Reset Password.
          </p>
        </div>
      </>
    );
  } else {
    content = <p>No additional information available.</p>;
  }

  return <div className="p-4">{content}</div>;
};

export default WhereUsedContent;
